export let fieldTypesSpecs = [
  {
    type: 'textarea',
    component: 'text-area-component'
  },
  {
    type: 'text',
    component: 'text-component'
  },
  {
    type: 'email',
    component: 'email-component'
  },
  {
    type: 'password',
    component: 'password-component'
  },
  {
    type: 'number',
    component: 'number-component'
  },
  {
    type: 'decimal',
    component: 'decimal-component'
  },
  {
    type: 'date',
    component: 'date-component'
  },
  {
    type: 'file',
    component: 'file-component'
  },
  {
    type: 'multiple-files',
    component: 'multiple-file-component'
  },
  {
    type: 'checkbox',
    component: 'checkbox-component'
  },
  {
    type: 'multiple-checkbox',
    component: 'multiple-checkbox-component'
  },
  {
    type: 'radio',
    component: 'radio-component'
  },
  {
    type: 'select',
    component: 'select-component'
  },
  {
    type: 'tag-input',
    component: 'tag-input-component'
  },
  {
    type: 'range',
    component: 'range-component'
  },
  {
    type: 'postal-code',
    component: 'postal-code-component'
  },
  {
    type: 'hidden',
    component: 'hidden-component'
  },
  {
    type: 'exam-choice',
    component: 'exam-choice-component'
  }
]
